import { gridClasses } from '@mui/x-data-grid';

const style = {
  // Estilização header tabela
  [`& .${gridClasses.columnHeader}`]: {
    color: '#666666',
    backgroundColor: '#f0f0f0',
  },
  [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]: {
    outline: 'none',
  },
  [`& .${gridClasses.iconButtonContainer} .MuiButtonBase-root,
    & .${gridClasses.menuIcon} .MuiButtonBase-root`]: {
    backgroundColor: 'transparent',
    color: '#353A40',
  },
  '& .MuiDataGrid-iconSeparator': {
    display: 'none',
  },
  // Estilização linhas, coluna e célula
  [`& .${gridClasses.row}`]: {
    '&:hover, &.Mui-hovered': {
      backgroundColor: '#ecddd8 !important',
      color: '#616161',
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
  },
  [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
    outline: 'none',
  },
  '& .MuiDataGrid-columnsContainer, & .MuiDataGrid-cell': {
    border: 'none',
  },
  '& .MuiDataGrid-virtualScroller': {
    minHeight: '39px',
  },
  // Alternação de cores par e ímpar
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: '#f8f8f8',
  },
  [`& .${gridClasses.row}.odd`]: {
    backgroundColor: '#ffffff',
  },
};
export default style;
